// ABOUTME: Hypothesis API calls for analysis data
// ABOUTME: Fetches hypothesis lists and detailed analyses

import { apiClient } from './client'
import type { CategoryInfo, AnalysisData } from '@/types/analysis'

export const hypothesesApi = {
  /**
   * Fetch all hypotheses grouped by category
   */
  async getHypotheses(category?: string): Promise<CategoryInfo[]> {
    const params = category ? { category } : {}
    const response = await apiClient.get<CategoryInfo[]>('/api/hypotheses', { params })
    return response.data
  },

  /**
   * Fetch detailed hypothesis analysis
   */
  async getHypothesisAnalysis(category: string, hypothesisId: string): Promise<AnalysisData> {
    const response = await apiClient.get<AnalysisData>(
      `/api/hypotheses/${category}/${hypothesisId}`
    )

    // Transform API response: construct analysis_metadata from top-level fields
    const data = response.data
    if (!data.analysis_metadata && (data.persona_count !== undefined || data.support_rate !== undefined)) {
      data.analysis_metadata = {
        persona_count: data.persona_count !== null ? data.persona_count : undefined,
        support_rate: data.support_rate !== null ? data.support_rate : undefined,
        controversial_score: data.controversy_score !== null ? data.controversy_score : undefined,
        top_personas: data.top_personas !== null ? data.top_personas : undefined,
        total_evidence: data.evidence_items?.length || 0,
      }
    }

    return data
  }
}
